import { axiosPublic, axiosPrivate } from "../utils";
import { toast } from 'react-toastify';

export const getAllLabProductExtras = async (data) => {
    const { labId } = data;
    try {
        const res = await axiosPrivate.get('lab-product-extra/all',{
            params: {
                labId: labId,
            }
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const viewLabProductExtra = async (data) => {
    const { productExtraId } = data;
    try {
        const res = await axiosPrivate.get(`lab-product-extra/${productExtraId}`);
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const createLabProductExtra = async (data) => {
    const { labId, name, price } = data;
    try {
        const res = await axiosPrivate.post('lab-product-extra/create', {
            labId: labId,
            name: name,
            price: price
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        toast.success(res.data.message);

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const editLabProductExtra = async (data) => {
    const { productExtraId, name, price } = data;
    try {
        const res = await axiosPrivate.put(`lab-product-extra/edit/${productExtraId}`, {
            name: name,
            price: price
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        toast.success(res.data.message);

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
} 